import { lazy } from 'react';
import PagosYRetenciones from '@Containers/PagosYRetenciones';

// Lazy loading de componentes privados
const Home = lazy(() => import('../Containers/Home'));
const User = lazy(() => import('../Containers/User'));
const UserDashboardInfo = lazy(() => import('../Containers/UserDashboardInfo'));
const UserDashboardNotifications = lazy(() => import('../Containers/UserDashboardNotifications'));
const Cartera = lazy(() => import('../Containers/Cartera'));
const LibreDeuda = lazy(() => import('../Containers/LibreDeuda'));
const Deudores = lazy(() => import('../Containers/Deudores'));
const PrimoPortal = lazy(() => import('../Containers/PrimoPortal'));
const AdminUsers = lazy(() => import('../Containers/AdminUsers'));
const AdminRoles = lazy(() => import('../Containers/AdminRoles'));
const AdminNotificaciones = lazy(() => import('../Containers/AdminNotificaciones'));
const HistorialNotificaciones = lazy(() => import('../Containers/HistorialNotificaciones'));
const AdminComunicaciones = lazy(() => import('../Containers/AdminComunicaciones'));
const AdminLeyendas = lazy(() => import('../Containers/AdminLeyendas'));
const HistorialComunicaciones = lazy(() => import('../Containers/HistorialComunicaciones'));
const SimulateProducer = lazy(() => import('../Containers/SimulateProducer'));
const Auditoria = lazy(() => import('../Containers/Auditoria'));
const Estadisticas = lazy(() => import('../Containers/Estadisticas'));
const Consultas = lazy(() => import('../Containers/Consultas'));
const ReferentesConsulta = lazy(() => import('../Containers/ReferentesConsulta'));
const Simuladores = lazy(() => import('../Containers/Simuladores'));
const RechazoMotivo = lazy(() => import('../Containers/RechazoMotivo'));
const Novedades = lazy(() => import('../Containers/Novedades'));
const Repositorio = lazy(() => import('../Containers/Repositorio'));
const Delegado = lazy(() => import('../Containers/User/Delegado'));
const Avanzadas = lazy(() => import('../Containers/Avanzadas'));
const Configuracion = lazy(() => import('../Containers/Configuracion'));
const ComisionesPendientes = lazy(() => import('../Containers/ComisionesPendientes'));
const LiquidacionesFacturasPendientes = lazy(() => import('../Containers/PagosYLiquidaciones'));
const ConceptosFacturar = lazy(() => import('../Containers/ConceptosFacturar'));
const Tutoriales = lazy(() => import('../Containers/Tutoriales'));
const FAQ = lazy(() => import('../Containers/FAQ'));

export const privateRoutes = [
  {
    path: '/user',
    component: User,
    breadcrumb: 'User'
  },
  {
    path: '/cartera',
    component: Cartera,
    breadcrumb: 'Búsqueda de cartera'
  },
  {
    path: '/libredeuda',
    component: LibreDeuda,
    breadcrumb: 'Libre deuda'
  },
  {
    path: '/comisiones-pendientes',
    component: ComisionesPendientes,
    breadcrumb: 'Comisiones pendientes'
  },
  {
    path: '/liquidaciones-facturas-pendientes',
    component: LiquidacionesFacturasPendientes,
    breadcrumb: 'Liquidaciones y facturas pendientes'
  },
    {
    path: '/pagos-retenciones',
    component: PagosYRetenciones,
    breadcrumb: 'Pagos y Retenciones'
  },
  {
    path: '/conceptos-a-facturar',
    component: ConceptosFacturar,
    breadcrumb: 'Conceptos a Facturar'
  },
  {
    path: '/home',
    component: Home,
    breadcrumb: 'Home'
  },
  {
    path: '/simulator',
    component: Simuladores,
    breadcrumb: 'Simuladores'
  },
  {
    path: '/rechazos',
    component: RechazoMotivo,
    breadcrumb: 'Rechazos por motivo'
  },
  {
    path: '/user-dashboard-info',
    component: UserDashboardInfo,
    breadcrumb: 'User Dashboard'
  },
  {
    path: '/user-dashboard-notifications',
    component: UserDashboardNotifications,
    breadcrumb: 'User Dashboard'
  },
  {
    path: '/deudores-policyExpired',
    component: Deudores,
    breadcrumb: 'Deudores por premio'
  },
  {
    path: '/deudores',
    component: Deudores,
    breadcrumb: 'Deudores por premio'
  },
  {
    path: '/deudas-y-pagos',
    component: PrimoPortal,
    breadcrumb: 'Deudas y Pagos'
  },
  {
    path: '/admin-users',
    component: AdminUsers,
    breadcrumb: 'Administrar usuarios',
    exact: true,
    adminOnly: true
  },
  {
    path: '/admin-roles',
    component: AdminRoles,
    breadcrumb: 'Administrar roles y permisos',
    exact: true,
    adminOnly: true
  },
  {
    path: '/delegado',
    component: Delegado,
    breadcrumb: 'Administrar delegados',
    exact: true,
    adminOnly: true
  },
  {
    path: '/simulate-producer',
    component: SimulateProducer,
    breadcrumb: 'Simular productor',
    menu_producer: false,
    exact: true
  },
  {
    path: '/adminnotificaciones',
    component: AdminNotificaciones,
    breadcrumb: 'Notificaciones',
    exact: true,
    adminOnly: true
  },
  {
    path: '/historialnotificaciones',
    component: HistorialNotificaciones,
    breadcrumb: 'Notificaciones',
    exact: true,
    adminOnly: true
  },
  {
    path: '/admincomunicaciones',
    component: AdminComunicaciones,
    breadcrumb: 'Comunicaciones',
    exact: true,
    adminOnly: true
  },
  {
    path: '/adminleyendas',
    component: AdminLeyendas,
    breadcrumb: 'Leyendas en las planillas',
    exact: true,
    adminOnly: true
  },
  {
    path: '/historialcomunicaciones',
    component: HistorialComunicaciones,
    breadcrumb: 'Comunicaciones',
    exact: true,
    adminOnly: true
  },
  {
    path: '/auditoria-productor',
    component: Auditoria,
    breadcrumb: 'Auditoria',
    exact: true,
    adminOnly: true
  },
  {
    path: '/estadisticas',
    component: Estadisticas,
    breadcrumb: 'Estadísticas',
    exact: true,
    adminOnly: true
  },
  {
    path: '/news',
    component: Novedades,
    breadcrumb: 'Marketing',
    exact: true,
    adminOnly: true
  },
  {
    path: '/repositorio',
    component: Repositorio,
    breadcrumb: 'Repositorio',
    exact: true,
    adminOnly: true
  },
  {
    path: '/consulta',
    component: Consultas,
    breadcrumb: 'Consultas'
  },
  {
    path: '/referentes-consulta',
    component: ReferentesConsulta,
    breadcrumb: 'Referentes de consulta'
  },
  {
    path: '/avanzadas',
    component: Avanzadas,
    breadcrumb: 'Avanzadas',
    menu_producer: false
  },
  {
    path: '/configuracion',
    component: Configuracion,
    breadcrumb: 'Configuración',
    adminOnly: true
  },

  {
    path: '/tutoriales',
    component: Tutoriales,
    breadcrumb: 'Tutoriales'
  },
  {
    path: '/faq',
    component: FAQ,
    breadcrumb: 'Preguntas frecuentes'
  }
];

// Funciones para filtrar rutas según el tipo de usuario
export const getRoutesForUser = (isAdmin, requirePasswordChange, requireProducerSelection) => {
  if (requirePasswordChange) {
    return privateRoutes.filter(route => route.path === '/recover-reset');
  }

  if (requireProducerSelection) {
    return privateRoutes.filter(route => route.menu_producer !== true);
  }

  if (isAdmin) {
    return privateRoutes;
  }

  return privateRoutes.filter(route => 
    route.path !== '/admin-users'
  );
};
